import Vue from 'vue'
import { Route } from 'vue-router'

/** リアクティブを保ったままObject.assign同様の合成を行う */
export function assignReactive(target: object, others: object) {
  Object.entries(others).forEach(([otherKey, otherValue]) => {
    if (!target.hasOwnProperty(otherKey)) {
      Vue.set(target, otherKey, otherValue)
    } else {
      target[otherKey] = otherValue
    }
  })
}

export function isSingleQuery(queryParam: Route['query'][string]): queryParam is string {
  return !Array.isArray(queryParam)
}
